import * as React from 'react';
import type { SVGProps } from 'react';

const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path fill="#fff" d="M20 12v10H4V12" />
    <path
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 12v10H4V12"
    />
    <path
      fill="#fff"
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22 7H2v5h20V7z"
    />
    <path
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 22V7"
    />
    <path
      fill="#fff"
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zm0 0h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
    />
  </svg>
);
export default SvgGift;
